import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DeploymentStatusDTO, ScrollerUpdateDTO, StormModeTelemetryHistoryRequest } from '@psnb/psnb-api';
import { AuthService, GeneratorService, isDefined, isDefinedNotNull, PowerSupplyService, PSScrollerUpdatesCodeService } from '@psnb/services';
import * as FileSaver from 'file-saver';
import * as Highcharts from 'highcharts';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { CommonService } from '../../common/common.service';
import { PowerSupplyMessageDialog } from '../../common/message-dialog/power-supply-message-dialog';
import { SharedService } from './datashared.service';
import { DeployGeneratorDialogComponent } from './deploy-generator-dialog/deploy-generator-dialog.component';
import { RefuelRecoveryGeneratorDialogComponent } from './refuel-recovery-generator-dialog/refuel-recovery-generator-dialog.component';
import { RefuelRecoverAction, TelemetryGeneratorViewModel, UserPermission } from './telemetry-generator.model';
import {
  PowerSupplyTelemetryPsScoredialogComponent
} from './power-supply-telementrydata-psScore-dialog/power-supply-telementrydata-psScore-dialog.component';
import {
  PowerSupplyTelemetryThresholddialogComponent
} from './power-supply-telemetry-thresholddialog/power-supply-telemetry-thresholddialog.component';

@Component({
  selector: 'nwt-power-supply-telemetry',
  templateUrl: './power-supply-telemetry.component.html',
  styleUrls: ['./power-supply-telemetry.component.scss']
})
export class PowerSupplyTelemetryComponent implements OnInit, OnDestroy, AfterViewInit {
  public vm: TelemetryGeneratorViewModel;

  private deployGeneratorDialogComponentRef: MatDialogRef<DeployGeneratorDialogComponent>;
  private destroyed$: Subject<void>;
  private extractedGeneratorId: string;
  private generatorDeployedData: DeploymentStatusDTO;
  private generatorMessage: string;
  private refuelRecoveryGeneratorDialogComponentRef: MatDialogRef<RefuelRecoveryGeneratorDialogComponent>;

  showMessage: boolean = false;
  messagescroll: string = '';
  duration: string = '';
  public powerSupplythresholdDialog: MatDialogRef<PowerSupplyTelemetryThresholddialogComponent>;
  showProgressBar: boolean = false;
  showProgressBartelemetry: boolean = false;
  showTelemetryResults: boolean = false;
  showTelemetryNoResults: boolean = false;
  macSearchTelemetry: any;
  macSearchTelemetryThreshold: any;
  headerRefresh: boolean = false;
  thresholdLabel: any;
  @Input() powerSupplyId: any;
  @Input() ip: String;
  @Input() macaddress: any;
  currentval: any;
  showTelemetryThreshold: boolean = true;
  refreshTime: any;
  spin: any;
  lastpolldate: any;
  headerMsg: any;
  telemetrynet: boolean = false;
  telemetry: boolean = false;
  showprogbar: boolean = false;
  showErrormsg: boolean = false;
  data: any;
  macaddressval : any;
  psname:any;
  colorValueoutvolt:any;
  colorValueoutpower:any;
  colorValuetotalstr:any;
  colorValuetemp:any;
  colorValueinvolt:any;
  colorValueoutcurr1:any;
  colorValueoutcurr2:any;
  colorbat1:any;
  colorbat2:any;
  colorbat3:any;
  colorbat4:any;
  colorbat5:any;
  colorbat6:any;
  colorbat7:any;
  colorbat8:any;
  colorbat9:any;
  colorbat10:any;
  colorbat11:any;
  colorbat12:any;
  colorbat13:any;
  colorbat14:any;
  colorbat15:any;
  colorbat16:any;
  colorbat17:any;
  colorbat18:any;
  colorbat19:any;
  colorbat20:any;
  colorbat21:any;
  colorbat22:any;
  colorbat23:any;
  colorbat24:any;
  sharedData: any;
  offlinetime: any;
  psExpectedFailureTimeFormated = null;
  psOnBatterySinceFormated = null;
  reftimedata:boolean = false;
  refcolor:any;
  timeStart:any;
  timeEnd:any;
  defaultValue:number = 12;
  showProgressBarcorrectruntime:boolean = false;
  private powerSupplyMessageDialog: MatDialogRef<PowerSupplyMessageDialog>;
  correctruntimedisabled:boolean = false;
  psScoreAlertDetails: import("@psnb/psnb-api").TelemetryDataResponse;
  //telemDataEnable : boolean;
  //transponderOpsEnable : boolean;
  userpermissions:boolean = false;
  currentvaltotal:any;
  colorValuetotal:any;
  ipCategory: boolean = false;
  telementryData: any;
  gpsgreaterFlag: boolean;
  parallelBatts : boolean;
  isLionBMS : boolean = false;
  addUrl: boolean = false;
  generatorId : number = 0;
  genMinRemaining : number;
  stormOutputCurr: string;
  pollTimeStormMode : string;
  stormReq:StormModeTelemetryHistoryRequest = {};
  mac: any;
  psIdtelemetry: any;
  permissions: any;

  constructor(
    private authService: AuthService,
    private readonly cdr: ChangeDetectorRef,
    private commonService: CommonService,
    private dialog: MatDialog,
    private generatorService: GeneratorService,
    private powerSupplyService: PowerSupplyService,
    private psScrollerUpdatesCodeService: PSScrollerUpdatesCodeService,
    private ref: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private sharedService: SharedService
  ) {
    this.destroyed$ = new Subject<void>();
    const url = window.location.href;
    if (url.includes('/telemetry-networkops')) {
      this.telemetrynet = true;
    } else if (url.includes('/telemetry')) {
      this.telemetry = true;
    }

    this.route.queryParams
    .subscribe(params => {
      this.mac = params['macAddress'];
      this.psIdtelemetry = params['powerSupplyId'];
      //this.psname = params['psname'];
      if(this.mac != null || this.mac != '' || this.mac != undefined){
        this.macaddress = this.mac;
        //this.psIdtelemetry = null;
      }else{
        this.macaddress = null;
        this.psIdtelemetry = params['powerSupplyId'];
      }
    });
  }

  ngOnInit(): void {
    this.vm = {
      generatorDeployed: false,
      generatorMinutesRuntime: undefined,
      generatorMinutesRuntimeConverted: undefined,
      recoverDeployEnabled: undefined,
      RefuelRecoverAction
    };

    this.fetchMessageAndDuration();
    let permissions = JSON.parse(localStorage.getItem('user-permissions'));
    if (this.permissions =='' || !this.authService.isAuthorizedPSNBUser) {
      this.router.navigate(['/unauthorized']);
    }
    this.sharedService.sharedData$.subscribe(sharedData => {
    this.sharedData = sharedData;
    this.parallelBatts = sharedData.parallel;
    this.isLionBMS = this.sharedData.lionBMS;
    this.powerSupplyId = this.sharedData['psId'];
    this.ip = this.sharedData['transponderIp'];
    });
    this.route.queryParams
    .subscribe(params => {
      this.powerSupplyId = params['powerSupplyId'];
      this.macaddress = params['macAddress'];
      //this.psname = params['psname'];
    });


    this.getTelemetrydatabyMac(this.macaddress,this.powerSupplyId);
    this.headerMsg = "Telemetry Data";
    //Getting mac address from parent component
    /*macaddress,ip,powerSupplyId */
    this.data = setInterval(() => {
      this.refresh();
    }, 60000);

    // Check generator deployment status
    if (isDefinedNotNull(this.powerSupplyId)) {
      this.checkDeploymentStatus(this.powerSupplyId);
    }
  }

  public ngAfterViewInit(): void {
    //Permission Check
    const userpermissions: UserPermission[] | undefined = JSON.parse(localStorage.getItem('user-permissions'));
    if (isDefined(userpermissions)) {
      for (const element of userpermissions) {
        if (element.category === CommonService.GENERATOR_ADMIN_ONLY &&
            element.functionality === CommonService.GENERATOR_RECOVERY_DEPLOY_BUTTON) {
          this.vm.recoverDeployEnabled = this.permissionlevel(element.permission);
        }
      }
    }
  }

  public ngOnDestroy(): void {
    if (this.data) clearInterval(this.data);
    this.destroyed$?.next();
    this.destroyed$?.complete();

    // Close any open dialogs
    this.deployGeneratorDialogComponentRef?.close();
    this.refuelRecoveryGeneratorDialogComponentRef?.close();
    this.powerSupplythresholdDialog?.close();
    this.powerSupplyMessageDialog?.close();
  }

  private permissionlevel(level: string): number {
    switch (level) {
      case CommonService.ENABLED:
        return 0;
      case CommonService.DISABLED:
        return 1;
      case CommonService.READONLY:
        return 2;
      default:
        return 2;
    }
  }

   /** Refresh - page reload only the user having admin access */
   refresh() {
    if (this.mac != null || this.mac != '' || this.mac != undefined) {
      this.macaddress = this.mac;
      this.powerSupplyId = null;
    } else {
      this.macaddress = null;
      //this.powerSupplyId = this.psIdtelemetry;
    }

    this.getTelemetrydatabyMac(this.macaddress,this.psIdtelemetry, true);
    // Adding check deployment status call for existing refresh
    this.checkDeploymentStatus(this.psIdtelemetry);
  }

  getthresholdcolorbar(thresholdData, currentValue){
    if(currentValue >= thresholdData.minValue && currentValue < thresholdData.alertLowValue){
      return "#FF2424";
    }else if(currentValue > thresholdData.alertLowValue && currentValue < thresholdData.warningLowValue){
      return "#F4FF02";
    }else if(currentValue > thresholdData.warningLowValue && currentValue < thresholdData.warningHighValue){
      return "#1aff1a";
    }else if(currentValue > thresholdData.warningHighValue && currentValue < thresholdData.alertHighValue){
      return "#F4FF02";
    }else if(currentValue > thresholdData.alertHighValue && currentValue < thresholdData.maxValue){
      return "#FF2424";
    }else if(currentValue < thresholdData.minValue || currentValue > thresholdData.maxValue) {
      return 'unset';
    }else{
      return null;
    }
  }

  thresholdcolorbar(thresholdData, colorcodeId, currentValue, thresholdLabel) {
    /**
    * Highcharts Linear-Gauge series plugin
    */
    (function (H) {
      H.seriesType('lineargauge', 'column', null, {
        setVisible: function () {
          //@ts-ignore
          H.seriesTypes.column.prototype.setVisible.apply(this, arguments);
          if (this.markLine) {
            this.markLine[this.visible ? 'show' : 'hide']();
          }
        },
        drawPoints: function () {
          // Draw the Column like always
          //@ts-ignore
          H.seriesTypes.column.prototype.drawPoints.apply(this, arguments);

          // Add a Marker
          var series = this,
            chart = this.chart,
            inverted = chart.inverted,
            xAxis = this.xAxis,
            yAxis = this.yAxis,
            point = this.points[0], // we know there is only 1 point
            markLine = this.markLine,
            ani = markLine ? 'animate' : 'attr';

          // Hide column
          point.graphic.hide();
          if (!markLine) {
            var path = inverted ? ['M', 0, 0, 'L', -5, -5, 'L', 5, -5, 'L', 0, 0, 'L', 0, 0 + xAxis.len] : ['M', 0, 0, 'L', -5, -5, 'L', -5, 5, 'L', 0, 0, 'L', xAxis.len, 0];
            markLine = this.markLine = chart.renderer.path(path)
              .attr({
                fill: series.color,
                stroke: series.color,
                'stroke-width': 1
              }).add();
          }
          markLine[ani]({
            translateX: inverted ? xAxis.left + yAxis.translate(point.y) : xAxis.left,
            translateY: inverted ? xAxis.top : yAxis.top + yAxis.len - yAxis.translate(point.y)
          });
        }
      });
    }(Highcharts));

    Highcharts.chart(colorcodeId, {
      chart: {
        type: 'lineargauge',
        inverted: true,
        height: 70
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      tooltip: { enabled: false },
      xAxis: {
        //lineColor: '#C0C0C0',
        labels: {
          enabled: false
        },
        tickLength: 0
      },
      yAxis: {
        min: thresholdData.minValue,
        max: thresholdData.maxValue,
        tickLength: 0,
        tickInterval: 0,
        title: null,
        labels: {
          format: '{value}'
        },
        plotBands: [{
          from: thresholdData.minValue,
          to: thresholdData.alertLowValue,
          color: '#FF2424'
        }, {
          from: thresholdData.alertLowValue,
          to: thresholdData.warningLowValue,
          color: '#F4FF02'
        }, {
          from: thresholdData.warningLowValue,
          to: thresholdData.warningHighValue,
          color: '#1aff1a'
        }, {
          from: thresholdData.warningHighValue,
          to: thresholdData.alertHighValue,
          color: '#F4FF02'
        }, {
          from: thresholdData.alertHighValue,
          to: thresholdData.maxValue,
          color: '#FF2424'
        }]
      },
      legend: {
        enabled: false
      },
      series: [{
        //@ts-ignore
        type: 'lineargauge',
        data: [currentValue],
        color: '#000000',
        dataLabels: {
          enabled: true,
          align: 'center',
          //format: '{point.y:,.2f}'
          format: '{point.y}' + thresholdLabel
        }
      }]

    }, // Add some life
      function (chart) {


      });
  }

  //Get the telemetry data by mac address
  getTelemetrydatabyMac(macaddress,powerSupplyId, refresh = false) {
    this.showProgressBartelemetry = true;
    this.spin = 'fa-spin';
    this.powerSupplyService.getPowerSupplyTelemetryData(macaddress,powerSupplyId).subscribe(result => {
      this.sharedService.setData(result);
      this.telementryData = result;
      this.macaddress = result['macAddress'];
      //calling the powerhouse generator API
      if (result.psId != null || result.psId != undefined) {
        this.powerSupplyService.getPowerHouseByPsId(result.psId).subscribe(resultGen => {
          if (resultGen != null) {
            this.genMinRemaining = resultGen.minutesLeft;
            this.generatorId = resultGen.generatorID;
          }
        }, err => {
          console.log("No Powerhouse data fetched due to an error!");
        });
      }

      // //gps link generation with trailing zeros
      if (result.gpsLatitude == null) {
        this.gpsgreaterFlag = true;
      } else {
        let gpslat = this.commonService.decimalCount(result.gpsLatitude);
        if (gpslat > 6) {
          this.gpsgreaterFlag = true;
        } else {
          this.gpsgreaterFlag = false;
        }
      }
      if (result.gpsLongitude == null) {
        this.gpsgreaterFlag = true;
      } else {
        let gpslong = this.commonService.decimalCount(result.gpsLongitude);
        if (gpslong > 6) {
          this.gpsgreaterFlag = true;
        } else {
          this.gpsgreaterFlag = false;
        }
      }

      this.psScoreAlertDetails = result;
      if (result.macAddress != null){
        this.macaddressval = result.macAddress.toUpperCase();
      }
      //When doing refresh, if the backend response has data then assign and show it in the screen otherwise show the old data
      if (refresh) {
        if (result.transponderIp != null && result.macAddress != null) {
          this.macSearchTelemetry = result;
        }
      } else {
        this.macSearchTelemetry = result;
      }

      //Setting StormMode start
      if (this.macSearchTelemetry.stormMode == 1) {
        this.stormReq.macAddress = this.macaddress;
        this.stormReq.nodeName = this.telementryData.nodes;
        this.stormReq.powerSupplyId = result.psId;
        this.powerSupplyService.getStormOutputCurrent(this.stormReq).subscribe(resultStorm => {
          if (resultStorm != null) {
            this.stormOutputCurr = resultStorm.outputCurrent1 ? resultStorm.outputCurrent1.toString() + ' Amps' : '-';
            this.pollTimeStormMode = (resultStorm.pollTimeStamp) ? new Date(resultStorm.pollTimeStamp).toLocaleString() : '-';
          }
        }, err => {
          console.log("No Storm Output Current data fetched due to an error!");
        });
      }
      //Setting StormMode end

      this.psExpectedFailureTimeFormated = (this.macSearchTelemetry.psExpectedFailureTime) ? new Date(this.macSearchTelemetry.psExpectedFailureTime).toLocaleString() : null;
      this.psOnBatterySinceFormated = (this.macSearchTelemetry.psOnBatterySince) ? new Date(this.macSearchTelemetry.psOnBatterySince).toLocaleString() : null;
      this.lastpolldate = new Date(this.macSearchTelemetry.timestamp * 1000).toLocaleString();
      this.refreshTime = new Date(this.macSearchTelemetry.timestamp * 1000).toLocaleString();
      if(this.macSearchTelemetry.inverterStatus == 'OFFLINE' && this.macSearchTelemetry.offlineTS != null){
        this.offlinetime = new Date(this.macSearchTelemetry.offlineTS).toLocaleString();
      } else{
        this.offlinetime = 'NA';
      }
      //ipv4 and ipv6 identification
      if(this.macSearchTelemetry.transponderIp != null ){
        this.ipCategory = this.macSearchTelemetry.transponderIp.includes('.') ? true : false;
         //check xm31 case -- contains needs to be add https
         if (this.macSearchTelemetry.psModel != null) {
           if (this.macSearchTelemetry.psModel.indexOf('XM31') !== -1) {
             this.addUrl = true;
           }
         }
      }
      if (this.macSearchTelemetry.transponderIp == null && this.macSearchTelemetry.macAddress == null) {
        this.showTelemetryResults = false;
        this.showTelemetryNoResults = true;
        this.showErrormsg = false;
      } else {
        if (refresh && this.macSearchTelemetryThreshold != null) {
          if (this.macSearchTelemetryThreshold != '' && this.macSearchTelemetryThreshold.length == 7) {
            this.setThresholdValues();
          } else {
            this.showTelemetryThreshold = false;
          }
        } else {
          this.powerSupplyService.getTelemetryThresholds(this.macaddress).subscribe(result => {
            this.macSearchTelemetryThreshold = result;
            if (this.macSearchTelemetryThreshold != '' && this.macSearchTelemetryThreshold.length == 7) {
              this.setThresholdValues();
            } else {
              this.showTelemetryThreshold = false;
            }
          });
        }
        this.showTelemetryResults = true;
        this.showTelemetryNoResults = false;
        this.showErrormsg = false;
      }
      this.showProgressBartelemetry = false;
      this.spin = '';
      if(this.macSearchTelemetry.timestamp != null){
        this.reftimedata = true;
        //check the 5 mins difference from poll date
        this.timeStart = new Date();
        this.timeEnd = new Date(this.macSearchTelemetry.timestamp * 1000)

        //var timeStart = new Date("Mon Jan 01 2007 05:50:00 GMT+0530").getTime();
        //var timeEnd = new Date("Mon Jan 01 2007 05:55:00 GMT+0530").getTime();
        //var hourDiff = timeEnd - timeStart; //in ms
        var hourDiff = this.timeStart - this.timeEnd; //in ms
        var minDiff = hourDiff / 60 / 1000; //in minutes
        var hDiff = hourDiff / 3600 / 1000; //in hours
        var hours = Math.floor(hDiff);
        var minutes = minDiff - 60 * hours;
        if(minDiff > 5){
          this.refcolor = "amber";
        }else{
          this.refcolor = "white";
        }

      }
    }, err => {
      this.showProgressBartelemetry = false;
      this.showErrormsg = true;
      this.showTelemetryResults = false;
      this.showTelemetryNoResults = false;
    });
  }

  setThresholdValues() {
    if (this.macSearchTelemetryThreshold != '' && this.macSearchTelemetryThreshold.length == 7) {
      //Calculation based on the seven variables
      this.showTelemetryThreshold = true;
      if (this.macSearchTelemetryThreshold[0]['alertHighValue'] == -1) this.showTelemetryThreshold = false;
      this.ref.detectChanges();
      if (!this.showTelemetryThreshold) return;
      this.macSearchTelemetryThreshold.forEach(res => {
        if (res.telemetryDataType === 'out_voltage') {
          this.thresholdLabel = ' Volt(s)';
          this.currentval = Math.round(this.macSearchTelemetry.outputVoltage * 100) / 100;
          //this.thresholdcolorbar(this.macSearchTelemetryThreshold[4], 'out_voltage', this.currentval, this.thresholdLabel);
          this.colorValueoutvolt = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[4],this.currentval);

        }
        if (res.telemetryDataType === 'out_power') { //no data for outpower it will be zero
          this.thresholdLabel = ' Watt(s)';
          this.currentval = Math.round(this.macSearchTelemetry.powerOut * 100) / 100;
          //this.thresholdcolorbar(this.macSearchTelemetryThreshold[3], 'out_power', this.currentval, this.thresholdLabel);
          this.colorValueoutpower = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[3],this.currentval);

        }
        if (res.telemetryDataType === 'total_string_voltage' && this.macSearchTelemetry.batteryCount != 0) {
          this.thresholdLabel = ' VDC';
          this.currentval = Math.round(this.macSearchTelemetry.totalBatteryStringVoltage * 100) / 100;
          //this.thresholdcolorbar(this.macSearchTelemetryThreshold[6], 'total_string_voltage', this.currentval, this.thresholdLabel);
          this.colorValuetotalstr = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[6],this.currentval);

        }
        if (res.telemetryDataType === 'temperature') {
          this.thresholdLabel = ' F';
          if(String(this.macaddress).toUpperCase().startsWith("00:0B:C9")){
            this.currentval = Math.round(this.macSearchTelemetry.internalTemperature * 100) / 100;
          } else{
            this.currentval = Math.round(this.macSearchTelemetry.outsideTemperatureFahrenheit * 100) / 100;
          }
          //this.thresholdcolorbar(this.macSearchTelemetryThreshold[5], 'temprature', this.currentval, this.thresholdLabel);
          this.colorValuetemp = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[5],this.currentval);
        }
        if (res.telemetryDataType === 'in_voltage') {
          this.thresholdLabel = ' VAC';
          this.currentval = Math.round(this.macSearchTelemetry.inputVoltage * 100) / 100;
          this.colorValueinvolt = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[1],this.currentval);
        }
        if (res.telemetryDataType === 'out_current') {
          this.thresholdLabel = ' Amp(s)';

            if(this.macSearchTelemetry.outputCurrent1 === null){
            //condition for showing output current 1 when value is null
            this.currentval = Math.round(this.macSearchTelemetry.outputCurrent1 * 100) / 100;
            this.colorValueoutcurr1 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[2],this.currentval);

            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[2], 'out_current1', this.currentval, this.thresholdLabel);
            } else{
              this.currentval = Math.round(this.macSearchTelemetry.outputCurrent1 * 100) / 100;
              this.colorValueoutcurr1 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[2],this.currentval);
              //this.thresholdcolorbar(this.macSearchTelemetryThreshold[2], 'out_current1', this.currentval, this.thresholdLabel);
            }
            if(this.macSearchTelemetry.outputCurrent2 === null){
              //condition for not showing output current 2 when value is null
            }else{
            this.currentval = Math.round(this.macSearchTelemetry.outputCurrent2 * 100) / 100;
            this.colorValueoutcurr2 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[2],this.currentval);
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[2], 'out_current2', this.currentval, this.thresholdLabel);
            }

            //Total Output Current
            if(this.macSearchTelemetry.outputCurrent1 != null && this.macSearchTelemetry.outputCurrent2 != null){
            this.currentvaltotal = Math.round((this.macSearchTelemetry.outputCurrent1 + this.macSearchTelemetry.outputCurrent2) * 100) / 100;
            this.colorValuetotal = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[2],this.currentvaltotal);
            }
        }


        if (res.telemetryDataType === 'Battery_voltage' && this.macSearchTelemetry.batteryCount != 0) {
          this.thresholdLabel = ' VDC';
          if (this.macSearchTelemetry.batteryVoltage1_1 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage1_1 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage1_1', this.currentval, this.thresholdLabel);
            this.colorbat1 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);

          }
          if (this.macSearchTelemetry.batteryVoltage1_2 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage1_2 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage1_2', this.currentval, this.thresholdLabel);
            this.colorbat2 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);

          }
          if (this.macSearchTelemetry.batteryVoltage1_3 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage1_3 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage1_3', this.currentval, this.thresholdLabel);
            this.colorbat3 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);

          }
          if (this.macSearchTelemetry.batteryVoltage1_4 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage1_4 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage1_4', this.currentval, this.thresholdLabel);
            this.colorbat4 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);

          }
          if (this.macSearchTelemetry.batteryVoltage2_1 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage2_1 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage2_1', this.currentval, this.thresholdLabel);
            this.colorbat5 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage2_2 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage2_2 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage2_2', this.currentval, this.thresholdLabel);
            this.colorbat6 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage2_3 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage2_3 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage2_3', this.currentval, this.thresholdLabel);
            this.colorbat7 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage2_4 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage2_4 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage2_4', this.currentval, this.thresholdLabel);
            this.colorbat8 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage3_1 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage3_1 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage3_1', this.currentval, this.thresholdLabel);
            this.colorbat9 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage3_2 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage3_2 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage3_2', this.currentval, this.thresholdLabel);
            this.colorbat10 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage3_3 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage3_3 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage3_3', this.currentval, this.thresholdLabel);
            this.colorbat11 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage3_4 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage3_4 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage3_4', this.currentval, this.thresholdLabel);
            this.colorbat12 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage4_1 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage4_1 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage4_1', this.currentval, this.thresholdLabel);
            this.colorbat13 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage4_2 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage4_2 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage4_2', this.currentval, this.thresholdLabel);
            this.colorbat14 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage4_3 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage4_3 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage4_3', this.currentval, this.thresholdLabel);
            this.colorbat15 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage4_4 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage4_4 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage4_4', this.currentval, this.thresholdLabel);
            this.colorbat16 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }

          if (this.macSearchTelemetry.batteryVoltage5_1 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage5_1 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage3_1', this.currentval, this.thresholdLabel);
            this.colorbat17 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage5_2 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage5_2 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage3_2', this.currentval, this.thresholdLabel);
            this.colorbat18 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage5_3 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage5_3 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage3_3', this.currentval, this.thresholdLabel);
            this.colorbat19 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage5_4 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage5_4 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage3_4', this.currentval, this.thresholdLabel);
            this.colorbat20 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage6_1 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage6_1 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage4_1', this.currentval, this.thresholdLabel);
            this.colorbat21 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage6_2 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage6_2 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage4_2', this.currentval, this.thresholdLabel);
            this.colorbat22 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage6_3 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage6_3 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage4_3', this.currentval, this.thresholdLabel);
            this.colorbat23 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
          if (this.macSearchTelemetry.batteryVoltage6_4 != null) {
            this.currentval = Math.round(this.macSearchTelemetry.batteryVoltage6_4 * 100) / 100;
            //this.thresholdcolorbar(this.macSearchTelemetryThreshold[0], 'batteryVoltage4_4', this.currentval, this.thresholdLabel);
            this.colorbat24 = this.getthresholdcolorbar(this.macSearchTelemetryThreshold[0],this.currentval);
          }
        }
      });
    }
  }

  editTestDuration(){
    //call the api calls
    this.correctruntimedisabled = true;
    this.showProgressBarcorrectruntime = true;
    this.powerSupplyService.setTestDurationByMac(this.macaddress,this.defaultValue).subscribe(result => {
      if (result.success === true) {
          this.showProgressBarcorrectruntime = false;
          this.correctruntimedisabled = false;
          this.openMessageDialog('Test Duration updated to '+ this.defaultValue + 'Mins. Will reflect in this page within an hour.');
      } else {
          this.correctruntimedisabled = false;
          //this.openMessageDialog('Unable to Correct Test Duration. Please try later !!');
          //US2378632-Prod break fix mapping endpoint dynamic message response in case of fail response
          this.openMessageDialog(result.message);
          this.showProgressBarcorrectruntime = false;
      }
  }, err => {
      this.correctruntimedisabled = false;
      this.showProgressBarcorrectruntime = false;
  });
  }

  openMessageDialog(message: string) {
    this.powerSupplyMessageDialog = this.dialog.open(PowerSupplyMessageDialog, {
      data: {
        message: message ? message : ''
      }
    })
  }



  openthresholdDialog(){
    this.powerSupplythresholdDialog = this.dialog.open(PowerSupplyTelemetryThresholddialogComponent, {
      data: {
        message: this.macSearchTelemetryThreshold ? this.macSearchTelemetryThreshold : ''
      },
      height: '90%',
      disableClose: false
    });
  }

  openPsScoreDialog() {
    this.dialog.open(PowerSupplyTelemetryPsScoredialogComponent, {
      data: {
        message: this.psScoreAlertDetails.psScoreAlertDetails
      },
      disableClose: false
    });
  }

  downloadPDF(){
    this.showProgressBartelemetry = true;
    const pdfName = 'XM360_' + this.powerSupplyId + '.pdf';
    this.powerSupplyService.getPsnbSdsPDFImageByPsId(this.powerSupplyId).subscribe(result => {
      if(result != null){
        var blob = new Blob([result], { type: "application/pdf"});
        FileSaver.saveAs(blob, pdfName);
        this.showProgressBartelemetry = false;
      } else{
        this.showProgressBartelemetry = false;
        this.openMessageDialog("No PDF images to download!");
      }
    }, err => {
      this.showProgressBartelemetry = false;
      this.openMessageDialog("No PDF images to download!");
    });
  }


  private fetchMessageAndDuration(): void {
    this.psScrollerUpdatesCodeService.fetchActiveScroller().subscribe((data: ScrollerUpdateDTO): void => {
    if (isDefinedNotNull(data.ntId)) {
      this.messagescroll = data.message;
      this.duration = data.duration;
      this.showMessage = true;
      setTimeout((): void => {
        this.showMessage = false;
      }, this.parseDuration(this.duration));
    }
    });
  }

  private parseDuration(duration: string): number {
    const [hours, minutes, seconds] = duration.split(':').map(Number);
    return (hours * 60 * 60 + minutes * 60 + seconds) * 1000; // Convert to milliseconds
  }

  // Generator Telemetry Changes
  public generatorSearchDialog(): void {
    if (isDefined(this.deployGeneratorDialogComponentRef)) {
      return;
    }
    this.deployGeneratorDialogComponentRef = this.dialog.open(DeployGeneratorDialogComponent, {
      data: {
        powerSupplyId: this.powerSupplyId
      },
      disableClose: true,
      panelClass: 'my-centered-dialog'
    });

    this.deployGeneratorDialogComponentRef.afterClosed()
      .pipe(take(1), takeUntil(this.destroyed$))
      .subscribe((deploymentResult: boolean): void => {
        if (deploymentResult) {
          this.checkDeploymentStatus(this.powerSupplyId);
        }
        this.deployGeneratorDialogComponentRef = undefined;
    });
  }

  public refuelRecoverGeneratorDialog(userAction: RefuelRecoverAction): void {
    if (isDefined(this.refuelRecoveryGeneratorDialogComponentRef)) {
      return;
    }
    this.checkDeploymentStatus(this.powerSupplyId);
    this.refuelRecoveryGeneratorDialogComponentRef = this.dialog.open(RefuelRecoveryGeneratorDialogComponent, {
      data: { action: userAction, generatorId: this.extractedGeneratorId },
      disableClose: true,
      panelClass: 'my-centered-dialog'
    });
    this.refuelRecoveryGeneratorDialogComponentRef.afterClosed()
      .pipe(take(1), takeUntil(this.destroyed$))
      .subscribe((refuelRecoveryResult: boolean | undefined): void => {
        if (refuelRecoveryResult) {
          this.checkDeploymentStatus(this.powerSupplyId);
        }
        this.refuelRecoveryGeneratorDialogComponentRef = undefined;
    });
  }

  private checkDeploymentStatus(powerSupplyId: number): void {
    this.generatorService.checkDeploymentStatus(powerSupplyId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((generatorData: DeploymentStatusDTO): void => {
        this.generatorDeployedData = generatorData;
        this.vm.generatorDeployed = this.generatorDeployedData?.generatorDeployedStatus;
        this.cdr.detectChanges();
        if (this.generatorDeployedData?.generatorDeployedStatus) {
          this.generatorMessage = this.generatorDeployedData?.message;
          const generatorIdMatch: RegExpMatchArray = this.generatorMessage?.match(/Generator ID:\s*(\d+)/);
          // Accept signed integers/floats and scientific notation (e.g. -2.9357627E7)
          const minutesRemainingMatch: RegExpMatchArray = this.generatorMessage?.match(
            /Remaining Runtime Minutes:\s*([+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/
          );
          if (isDefinedNotNull(generatorIdMatch)) {
            this.extractedGeneratorId = generatorIdMatch[1];
          }
          if (isDefinedNotNull(minutesRemainingMatch?.[1])) {
            const viewFullMinutes: string = minutesRemainingMatch[1];
            this.vm.generatorMinutesRuntime = viewFullMinutes;
            // Store numeric conversion (signed) for calculations
            const parsedData: number = Number(viewFullMinutes);
            this.vm.generatorMinutesRuntimeConverted = isNaN(parsedData) ? undefined : parsedData;
            this.cdr.detectChanges();
          } else {
            // clear or set to undefined if not present
            this.vm.generatorMinutesRuntime = undefined;
            this.vm.generatorMinutesRuntimeConverted = undefined;
            this.cdr.detectChanges();
          }
        }
      });
  }

}
